import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Col, Row, Skeleton } from 'antd'
//
import global from 'common'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { BenefitStartDateValues } from 'core/application/adminDashboard/benefitDetails/design/common/models'
import {
  getBenefitStartDateApi,
  postBenefitStartDateApi,
} from 'core/application/adminDashboard/benefitDetails/design/qsehra'

import Radio from 'common/components/dataEntry/formik/FormikRadioField'

import { parseZoneFormatShortMonthYear } from 'common/dateFormatters'

import { BaseComponentProps } from '../../common/models'

//
import '../../common/DesignStyles.less'
import './qsehraBenefitStartDate.less'

type InitialValues = {
  selectedDate: string
}

const QsehraBenefitStartDate: React.FC<BaseComponentProps<BenefitStartDateValues>> = (props) => {
  const { bindSubmitFormHandler } = props
  const { t: translate } = useTranslation()
  const { planPeriod } = useParams() as any
  const [initialValues] = useState<InitialValues>({
    selectedDate: props.state.benefitStartDate || '',
  })

  const [availableBenefitStartDate, benefitStartDateLoading, getBenefitStartDate] = global.hooks.useQueryRequest<
    string[]
  >([])

  const [, postBenefitStartDateLoading, postBenefitStartDate] = global.hooks.useQueryRequest<string[]>([])

  useEffect(() => {
    if (initialValues.selectedDate) {
      props.setIsFormValid(true)
    }
  }, [initialValues.selectedDate])

  useEffect(() => {
    if (props?.state?.planPeriodId) {
      getBenefitStartDate(() => getBenefitStartDateApi(planPeriod))
    }
  }, [props?.state?.planPeriodId])

  useEffect(() => {
    if (postBenefitStartDateLoading) {
      props.setIsSubmiting(postBenefitStartDateLoading)
    }
  }, [postBenefitStartDateLoading])

  const onSubmit = async (values: { selectedDate: string }) => {
    try {
      await postBenefitStartDate(() =>
        postBenefitStartDateApi({
          benefitStartDate: values.selectedDate,
          planPeriodId: planPeriod,
        }),
      )
      props.goNext()
    } catch (e) {
      props.setIsSubmiting(false)
    }
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={(values) => {
        props.hasDirtyData(true)
        props.setIsFormValid(formValidator(translate).isValidSync(values))
        return {}
      }}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Row className={'mb-32'}>
              <Col span={17} className={'benefit_design_page_header'}>
                <h5>{translate('admin-dashboard.benefit-details.qsehra-benefit-start-date.header')}</h5>

                <h6 className={'inline mr-8'}>
                  {translate('admin-dashboard.benefit-details.qsehra-benefit-start-date.subheader')}
                </h6>

                <global.components.dataDisplay.Tooltip
                  title={translate('admin-dashboard.benefit-details.qsehra-benefit-start-date.subheader-info-tooltip')}
                >
                  <global.components.general.Icon type={'far fa-info-circle'}></global.components.general.Icon>
                </global.components.dataDisplay.Tooltip>
              </Col>
            </Row>

            <Row>
              <Col span={17}>
                <Skeleton loading={benefitStartDateLoading}>
                  <Radio.Group
                    name="selectedDate"
                    className="qsehra-benefit-start-date qsehra-benefit-design-radio-group"
                  >
                    {availableBenefitStartDate.map((item) => (
                      <Radio.Button key={item} value={item} size="small" className="mb-8">
                        {parseZoneFormatShortMonthYear(item)}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </Skeleton>
              </Col>
            </Row>
          </form>
        )
      }}
    </Formik>
  )
}

const formValidator = (translate: any) =>
  Yup.object({
    selectedDate: Yup.string().required(translate('general.required')).nullable(),
  })

export default QsehraBenefitStartDate
